import { useEffect, useRef } from 'react';
import scrollEventFn from '../scroll_event';

export default function Vision() {
  const scroll01 = useRef(null);
  const scroll02 = useRef(null);
  const scroll03 = useRef(null);
  const scroll04 = useRef(null);
  const scroll05 = useRef(null);
  const scroll06 = useRef(null);
  const scroll07 = useRef(null);
  const scroll08 = useRef(null);
  const scrollArr = [
    scroll01,
    scroll02,
    scroll03,
    scroll04,
    scroll05,
    scroll06,
    scroll07,
    scroll08,
  ];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const cb = () => scrollEventFn(scrollArr);
    cb();
    window.addEventListener('scroll', cb);
    return () => window.removeEventListener('scroll', cb);
  }, []);

  return (
    <div className="contents vision">
      <div className="content-title02">VISION</div>
      <div className="vision_wrap_01">
        <div className="vision_box_01 scrollBox" ref={scroll01}>
          <div className="vision_img">
            <img src="/img/sub_vision_01.png" alt="" />
          </div>
          <div className="info">
            <p>
              ㈜DX손해사정법인은
              <br /> 혁신적인 IT 솔루션과의 결합을 통해 <br /> 고객의 미래가치를
              한단계 성장시킵니다.
            </p>
          </div>
        </div>
        <div className="vision_box_01 scrollBox" ref={scroll02}>
          <div className="vision_img">
            <img src="/img/sub_vision_02.png" alt="" />
          </div>
          <div className="info">
            <p>
              ㈜DX손해사정법인은
              <br /> 모두가 닮고 싶은 기업,
              <br /> 누구나 일하고 싶은 기업이 되겠습니다.
            </p>
          </div>
        </div>
        <div className="vision_box_01 scrollBox" ref={scroll03}>
          <div className="vision_img">
            <img src="/img/sub_vision_03.png" alt="" />
          </div>
          <div className="info">
            <p>
              ㈜DX손해사정법인은
              <br /> 끊임없이 성장하며
              <br /> 고객이 먼저 찾는 기업이 되겠습니다.
            </p>
          </div>
        </div>
      </div>
      <h5 className="content-title02 top-150">경영원칙</h5>
      <div>
        <div className="vision_box_02">
          <ul>
            <li className="durationLi scrollBox" ref={scroll04}>
              <img src="/img/sub_vision_icon01.png" alt="" />
              <strong>지속 가능한 이익 경영</strong>
              <br />
              <br />
              <span>
                우리는 기업의 지속 가능한
                <br /> 이익 경영을 최우선적으로 실천합니다.
              </span>
            </li>
            <li className="durationLi scrollBox" ref={scroll05}>
              <img src="/img/sub_vision_icon02.png" alt="" />
              <strong>신뢰하는 행복한 기업</strong>
              <br />
              <br />
              <span>
                우리는 신뢰를 바탕으로 주주/고객/임직원 모두가 행복한 기업을
                만들어갑니다.
              </span>
            </li>
            <li className="durationLi scrollBox" ref={scroll06}>
              <img src="/img/sub_vision_icon03.png" alt="" />
              <strong>R&amp;D 경영 중심</strong>
              <br />
              <br />
              <span>
                우리는 최고의 창의성과 창조적인 R&amp;D를 경영의 중심으로
                합니다.
              </span>
            </li>
            <li className="durationLi scrollBox" ref={scroll07}>
              <img src="/img/sub_vision_icon04.png" alt="" />
              <strong>모든 구성원 행복 추구</strong>
              <br />
              <br />
              <span>
                우리는 이를 통해 합법적으로 함께하는 모든 분들의 행복을
                추구합니다.
              </span>
            </li>
          </ul>
        </div>
        <img
          src="/img/sub_vision_04.png"
          alt=""
          className="top-100 scrollBox"
          ref={scroll08}
        />
      </div>
    </div>
  );
}
